module.exports = __webpack_public_path__ + "img/new-editorial.72088f4b.png";